import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getInvoice = createAsyncThunk(
  "/invoice/getInvoiceList",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/invoice/getInvoiceList",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getInvoiceById = createAsyncThunk(
  "invoice/getInvoiceById",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/invoice/getInvoiceById",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getInvoiceByPatientId = createAsyncThunk(
  "invoice/getInvoiceByPatientAndClientId",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/invoice/getInvoiceByPatientAndClientId",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getTodayRevenue = createAsyncThunk(
  "/invoice/getTodayRevenue",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/invoice/getTodayRevenue",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getInvoiceRegistrationStates = createAsyncThunk(
  "/invoice/getInvoiceRegistrationStates",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/invoice/getInvoiceRegistrationStates",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllDataByPatientId = createAsyncThunk(
  "invoice/getAllDataByPatientId",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/invoice/getAllDataByPatientId",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
const initialState = {
  loading: false,
  invoice: [],
  invoiceInFo: [],
  allPatientInvoice: [],
  patientDetails: {},
  patientDetailsForPatientId: null,
  patientDetailsRequestId: null,
  searchMessage: "",
  totalRevenue: null,
  invoiceStatus: {
    yesterdayInvoiceCount: 0,
    todayInvoiceCount: 0,
    registrationInvoicePercentage: "0%",
  },
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    resetInvoiceData: (state) => {
      state.invoice = [];
      state.invoiceData = null;
      state.invoiceStatus = {
        yesterdayInvoiceCount: 0,
        todayInvoiceCount: 0,
        registrationInvoicePercentage: "0%",
      };
    },
    resetPatientInvoiceDetailsState: (state) => {
      state.patientDetails = {};
      state.patientDetailsForPatientId = null;
      state.patientDetailsRequestId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvoice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.invoice = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.invoice = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = false;
        state.searchMessage = null;
      })
      .addCase(getInvoice.rejected, (state, action) => {
        state.loading = false;
        state.searchMessage = action?.payload?.result?.message;
      })
      .addCase(getInvoiceById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvoiceById.fulfilled, (state, action) => {
        state.loading = false;
        state.invoiceInFo = action.payload.result.list;
      })
      .addCase(getInvoiceById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getInvoiceByPatientId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvoiceByPatientId.fulfilled, (state, action) => {
        state.loading = false;
        state.allPatientInvoice = action.payload.result.list;
      })
      .addCase(getInvoiceByPatientId.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getTodayRevenue.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTodayRevenue.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
          state.invoice = [];
        } else {
          state.invoice = action.payload.result.list;
          state.totalRevenue = action.payload.result.list.totalRevenue;
        }
      })
      .addCase(getTodayRevenue.rejected, (state, action) => {
        state.loading = false;
        state.searchMessage = action?.payload?.result?.message;
      })
      .addCase(getInvoiceRegistrationStates.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvoiceRegistrationStates.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.errorMessage = action.payload.result.message;
        } else {
          state.invoiceStatus = action.payload.result.list;
        }
      })
      .addCase(getInvoiceRegistrationStates.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })
      .addCase(getAllDataByPatientId.pending, (state, action) => {
        state.loading = true;
        state.patientDetails = {};
        state.patientDetailsForPatientId = String(action.meta.arg?.patientId || "");
        state.patientDetailsRequestId = action.meta.requestId;
      })
      .addCase(getAllDataByPatientId.fulfilled, (state, action) => {
        if (state.patientDetailsRequestId !== action.meta.requestId) return;
        state.loading = false;
        if (action.payload.success === false) {
          state.errorMessage = action.payload.result.message;
          state.patientDetails = {};
        } else {
          state.patientDetails =
            action?.payload?.result?.list || action?.payload?.result || {};
        }
      })
      .addCase(getAllDataByPatientId.rejected, (state, action) => {
        if (state.patientDetailsRequestId !== action.meta.requestId) return;
        state.loading = false;
        state.patientDetails = {};
        state.errorMessage = action.payload;
      });
  },
});
export const { resetInvoiceData, resetPatientInvoiceDetailsState } =
  invoiceSlice.actions;
export default invoiceSlice.reducer;
